"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var singlentone_1 = require("./singlentone");
exports.styleSinglentone = function () {
    var sheet = singlentone_1.stylesheetSinglentone();
    return (function (_super) {
        __extends(Sheet, _super);
        function Sheet() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.sheet = null;
            return _this;
        }
        Sheet.prototype.componentDidMount = function () {
            sheet.add(this.props.styles);
        };
        Sheet.prototype.componentWillUnmount = function () {
            sheet.remove();
        };
        Sheet.prototype.render = function () {
            return null;
        };
        return Sheet;
    }(React.PureComponent));
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-style-singleton/dist/component.js
// module id = 207
// module chunks = 0